function getUrlParams(url) {
    let hashes = url.slice(url.indexOf('?') + 1).split('&');
    let parameters = {};
    hashes.map(hash => {
        let [key, value] = hash.split('=');
        parameters[key] = decodeURIComponent(value);
    })

    return parameters;
}

module.exports = {
    getUrlParameters: function (url) {
        getUrlParams(url);
    },
    getUrlParameter: function (url, parameter) {
        let params = getUrlParams(url);

        return params[parameter];
    },
    redirectTo: function (url) {
        window.location = url;
    },
    reload: () => {
      window.location.reload();
    }
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/helpers/url.js